import { render, staticRenderFns } from "./OnboardingCheckListCard.vue?vue&type=template&id=59c872fa&scoped=true&"
import script from "./OnboardingCheckListCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OnboardingCheckListCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OnboardingCheckListCard.vue?vue&type=style&index=0&id=59c872fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c872fa",
  null
  
)

export default component.exports